export const STATUS_STYLE = {
  DISPONIBILE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  NON_DISPONIBILE: "bg-rose-50 text-rose-700 border-rose-200",
  RESCUE: "bg-sky-50 text-sky-700 border-sky-200",
  TRASFERITO: "bg-orange-50 text-orange-700 border-orange-200",
};

export const CONTRACT_STYLE = {
  LT: "bg-slate-900 text-white",
  MT: "bg-indigo-100 text-indigo-700",
  BT: "bg-amber-100 text-amber-800",
  LEASING: "bg-teal-100 text-teal-800",
  PROPRIETA: "bg-indigo-100 text-indigo-800",
};

export const FleetStatusBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLE[status] || ""}`}>{label}</span>
);
